import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import ContractRefundPayee from 'models/sales/contractRefundPayee/Model.ContractRefundPayee';
import ContractRefundPaymentItem from '../contractRefundPaymentItem/Model.ContractRefundPaymentItem';
import PostingAccount from '../postingAccount/Model.PostingAccount';
import contractRefundPaymentCancelApi from './cancel/Api.ContractRefundPayment.Cancel';
import contractRefundPaymentFindApi from './find/Api.ContractRefundPayment.Find';
import contractRefundPaymentListApi from './list/Api.ContractRefundPayment.List';
import contractRefundPaymentSaveApi from './save/Api.ContractRefundPayment.Save';

export default class ContractRefundPayment
  extends Model<Model.IContractRefundPayment>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractRefundPayment>
{
  id: number;

  amountPaid: number = 0;
  gstHstAmountPaid: number = 0;
  provincialSalesTaxAmountPaid: number = 0;
  readonly totalPaidAmt: number;

  currency: string = 'CAD';
  explanation: string;
  referenceNumber: string;
  status: string;
  createdAtLocal: string;
  createdAtUtc: string;
  modifiedAtUtc: string;
  transactionDateUtc: string;
  paymentDateUtc: string;
  paymentMethodCode: string;

  bankTransit: string;
  bankBranch: string;
  bankAccount: string;

  chequeNumber: string;

  transactionNumber: string;
  paymentEmailAddress: string;
  remittanceEmailAddress: string;
  isAutoDepositEnabled: boolean;
  eTransferQuestion: string;
  eTransferAnswer: string;

  isCancelled: boolean;

  contractRefundPaymentItems?: ContractRefundPaymentItem[];

  contractRefundPaymentPayeeId: number;
  contractRefundPaymentPayee?: ContractRefundPayee;

  ownerId?: number;
  owner?: User;

  ledgerAccountId?: number;
  ledgerAccount?: PostingAccount;

  remittanceDocumentId?: number;
  remittanceDocument?: MediaFile;

  readonly numberOfItems?: number;

  constructor(
    data: Partial<Model.IContractRefundPayment> | Utils.FormData<Model.IContractRefundPayment>,
    language?: Locale.Languages
  ) {
    super(
      {
        ledgerAccount: PostingAccount,
        remittanceDocument: MediaFile,
        contractRefundPaymentPayee: ContractRefundPayee,
        owner: User,
        contractRefundPaymentItems: [ContractRefundPaymentItem],
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }

  static async find(params: { id: number }) {
    const { payload, ...rest } = await contractRefundPaymentFindApi(params);
    return {
      ...rest,
      payload: new ContractRefundPayment(payload),
    };
  }

  static async list(body?: Api.Finance.ContractRefundPayment.List.IRequest) {
    const { payload, ...rest } = await contractRefundPaymentListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractRefundPayment(it)),
        count: payload.count,
      },
    };
  }

  static async create(body: Api.Finance.ContractRefundPayment.Save.IRequest) {
    return await contractRefundPaymentSaveApi(body);
  }

  static async cancel(params: { id: number }) {
    return await contractRefundPaymentCancelApi(params);
  }
}
